import React from 'react';
import Logo from './Logo';
import { AppSection } from '../types';

interface FooterProps {
  onNavigate: (section: AppSection) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer className="bg-slate-50 border-t border-slate-200 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 lg:grid-cols-5 gap-12 mb-20">
          <div className="col-span-2">
            <div className="flex items-center space-x-3 mb-8 cursor-pointer group" onClick={() => onNavigate(AppSection.Home)}>
              <Logo className="w-8 h-8 group-hover:scale-110 transition-transform" />
              <span className="text-xl font-bold tracking-tight text-slate-900 uppercase">Hunargrid</span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed max-w-sm font-light">
              Headquartered in Chicago, IL. Hunargrid is the primary delivery partner for enterprises seeking technical velocity and strategic clarity. Built on Midwest reliability and global technical expertise.
            </p>
          </div>
          
          <div>
            <h4 className="text-xs font-bold text-slate-900 uppercase tracking-[0.2em] mb-8">Engines</h4>
            <ul className="space-y-4 text-sm text-slate-500">
              <li><button onClick={() => onNavigate(AppSection.Solutions)} className="hover:text-[#0091da] transition-colors">Project Solutions</button></li>
              <li><button onClick={() => onNavigate(AppSection.Talent)} className="hover:text-[#0091da] transition-colors">Expert Staffing</button></li>
              <li><button onClick={() => onNavigate(AppSection.CaseStudies)} className="hover:text-[#0091da] transition-colors">Case Studies</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold text-slate-900 uppercase tracking-[0.2em] mb-8">Company</h4>
            <ul className="space-y-4 text-sm text-slate-500">
              <li><button onClick={() => onNavigate(AppSection.About)} className="hover:text-[#0091da] transition-colors">About Us</button></li>
              <li><button onClick={() => onNavigate(AppSection.Solutions)} className="hover:text-[#0091da] transition-colors">Our Process</button></li>
              <li><button onClick={() => onNavigate(AppSection.Talent)} className="hover:text-[#0091da] transition-colors">Careers</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold text-slate-900 uppercase tracking-[0.2em] mb-8">Contact</h4>
            <ul className="space-y-4 text-sm text-slate-500">
              <li>
                <a href="mailto:support@hunargrid.com" className="hover:text-[#0091da] transition-colors flex items-center">
                  <span className="mono text-[10px] mr-2 text-[#0091da]">E_</span> support@hunargrid.com
                </a>
              </li>
              <li>
                <a href="tel:+17088092959" className="hover:text-[#0091da] transition-colors flex items-center">
                  <span className="mono text-[10px] mr-2 text-[#0091da]">P_</span> 1 (708) 809-2959
                </a>
              </li>
              <li className="pt-2">
                <span className="text-[11px] text-slate-400 block uppercase tracking-widest">Chicago HQ</span>
                <span className="text-xs">Loop District, IL</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-200 pt-10 flex flex-col md:flex-row justify-between items-center text-[10px] text-slate-400 uppercase tracking-widest mono">
          <p>© 2025 Hunargrid Professional Services. Chicago, IL.</p>
          <div className="flex space-x-8 mt-6 md:mt-0">
            <button onClick={() => onNavigate(AppSection.About)} className="hover:text-[#0091da] transition-colors">Privacy Policy</button>
            <button onClick={() => onNavigate(AppSection.About)} className="hover:text-[#0091da] transition-colors">Terms of Service</button>
            <button onClick={() => onNavigate(AppSection.Solutions)} className="hover:text-[#0091da] transition-colors">Security Audit</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;